module.exports = __webpack_public_path__ + "img/DFM.853dd977.jpg";